module.exports = __webpack_public_path__ + "static/media/xs.5d09b7df.svg";